export default "__VITE_ASSET__DH6tIo6K__"